import type { ClonePersonInformationDto } from '../dto';
import type { ClonePersonInformation } from '../models';

export const mapClonePersonInformationToDto = (
  model: ClonePersonInformation,
): ClonePersonInformationDto => ({
  ...model,
});
